'use strict';

var keyboardAccessibility = require('base/components/keyboardAccessibility');

var menuOpenTimer;
var clearSelection = function (element) {
	$(element).closest('.dropdown.show').removeClass('show');
	$(element).closest('.dropdown').children('.dropdown-menu').children('.top-category')
		.detach();
	$(element).closest('.dropdown.show').children('.nav-link').attr('aria-expanded', 'false');
	$(element).closest('.dropdown.show').children('.dropdown-menu').attr('aria-hidden', 'true');
	$('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'false');
	$(element).closest('li').detach();
};

module.exports = function () {
	var isDesktop = function (element) {
		return $(element).parents('.menu-toggleable-left').css('position') !== 'fixed';
	};

	var headerBannerStatus = window.sessionStorage.getItem('hide_header_banner');
	$('.header-banner .close').on('click', function () {
		$('.header-banner').addClass('d-none');
		window.sessionStorage.setItem('hide_header_banner', '1');
	});

	if (!headerBannerStatus || headerBannerStatus < 0) {
		$('.header-banner').removeClass('d-none');
	}

	keyboardAccessibility('.main-menu .nav-link, .main-menu .dropdown-link',
		{
			40: function (menuItem) { // down
				if (menuItem.hasClass('nav-item')) { // top level
					$('.navbar-nav .show').removeClass('show')
						.children('.dropdown-menu')
						.removeClass('show');
					menuItem.addClass('show').children('.dropdown-menu').addClass('show');
					menuItem.find('ul > li > a')
						.first()
						.focus();
				} else {
					menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
					if (!(menuItem.next().length > 0)) { // if this is the last menuItem
						menuItem.parent().parent().find('li > a') // set focus to the first menuitem
							.first()
							.focus();
					} else {
						menuItem.next().children().first().focus();
					}
				}
			},
			39: function (menuItem) { // right
				if (menuItem.hasClass('nav-item')) { // top level
					menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
					$(this).attr('aria-expanded', 'false');
					menuItem.next().children().first().focus();
				} else if (menuItem.hasClass('dropdown')) {
					menuItem.addClass('show').children('.dropdown-menu').addClass('show');
					$(this).attr('aria-expanded', 'true');
					menuItem.find('ul > li > a')
						.first()
						.focus();
				}
			},
			38: function (menuItem) { // up
				if (menuItem.hasClass('nav-item')) { // top level
					menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
				} else if (menuItem.prev().length === 0) { // first menuItem
					menuItem.parent().parent().removeClass('show')
						.children('.nav-link')
						.attr('aria-expanded', 'false');
					menuItem.parent().children().last().children() // set the focus to the last menuItem
						.first()
						.focus();
				} else {
					menuItem.prev().children().first().focus();
				}
			},
			37: function (menuItem) { // left
				if (menuItem.hasClass('nav-item')) { // top level
					menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
					$(this).attr('aria-expanded', 'false');
					menuItem.prev().children().first().focus();
				} else {
					menuItem.closest('.show').removeClass('show')
						.closest('li.show').removeClass('show')
						.children()
						.first()
						.focus()
						.attr('aria-expanded', 'false');
				}
			},
			27: function (menuItem) { // escape
				var parentMenu = menuItem.hasClass('show')
					? menuItem
					: menuItem.closest('li.show');
				parentMenu.children('.show').removeClass('show');
				parentMenu.removeClass('show').children('.nav-link')
					.attr('aria-expanded', 'false');
				parentMenu.children().first().focus();
			}
		},
		function () {
			return $(this).parent();
		}
	);

	$('.dropdown:not(.disabled) [data-toggle="dropdown"]')
		.on('click', function (e) {
			if (!isDesktop(this)) {
				$('.modal-background').show();
				$(this).parents().find('.new-menu').addClass('dropdown-menu');
				$(this).siblings().find('.menu-item-container').addClass('dropdown-item');
				$(this).siblings().find('.menu-item-container').addClass('dropdown');
				$(this).siblings().find('.menu-item').addClass('dropdown-item');
				$(this).siblings().find('.flyout-menu-wrapper').children('ul').appendTo($(this).parent());
				$(this).siblings('.flyout-menu').hide();
				// copy parent element into current UL
				var li = $('<li class="dropdown-item top-category" role="button"><a class="back-btn"></a></li>');
				var link = $(this).clone().removeClass('dropdown-toggle')
					.removeAttr('data-toggle')
					.removeAttr('aria-expanded')
					.attr('aria-haspopup', 'false');
				li.append(link);
				$($(this).parents().children('.dropdown-menu')[0])
					.prepend(li).attr('aria-hidden', 'false');

				// copy navigation menu into view
				$(this).parent().addClass('show');
				$('.main-menu.menu-toggleable-left .search-mobile').addClass('d-none');
				$(this).attr('aria-expanded', 'theronarue');
				$(link).focus();
				$('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'true');
				e.preventDefault();
			}
		});

	$('.dropdown:not(.disabled) [data-toggle="dropdown"], .main-menu .nav-item [role="link"]').on('mouseenter', function() { 
		if (isDesktop(this)) {
			var eventElement = this;
			clearTimeout(menuOpenTimer);
			menuOpenTimer =	setTimeout(function() {
				$(eventElement).siblings('ul').appendTo($(eventElement).siblings('.flyout-menu'));
				$(eventElement).parents('.nav-item').siblings().removeClass('show');
				$(eventElement).parents('.nav-item').siblings().find('.flyout-menu').removeClass('show');
				var $currentFlyout = $(eventElement).siblings('.flyout-menu');
				$currentFlyout.find('.new-menu').removeClass('dropdown-menu');
				$currentFlyout.find('.menu-item-container').removeClass('dropdown-item');
				$currentFlyout.find('.menu-item-container').removeClass('dropdown');
				$currentFlyout.find('.menu-item').removeClass('dropdown-item');
				$(eventElement).parent().addClass('show');
				if($currentFlyout.length > 0){
					//Single-level Alignment for Flyout menu
					var flyoutwrapper = $currentFlyout.children('.flyout-menu-wrapper');
					($currentFlyout.find('.new-menu') && $currentFlyout.find('.new-menu').children('li').length <= 12) ? flyoutwrapper.addClass('single-level') :  flyoutwrapper.removeClass('single-level');
					$currentFlyout.addClass('show');
					$currentFlyout.show();
					$('.global-header').addClass('overlay');
					$('.overlay-background').show();
				}
			}, 300);
		}
	});
	$('.dropdown:not(.disabled) [data-toggle="dropdown"], .main-menu .nav-item [role="link"]').parents('.menu-group').on('mouseleave', function() {
		if (isDesktop(this)) {
			clearTimeout(menuOpenTimer);
			$(this).find('.nav-item').removeClass('show');
			$(this).find('.flyout-menu').removeClass('show');
			$('.overlay-background').hide();
			$('.global-header').removeClass('overlay');
			$(this).find('.nav-link').attr('aria-expanded', 'false');
		}
	});

	$('.navbar-toggler-close').on('click', function (e) {
		e.preventDefault();
		$('.navbar-nav').find('.top-category').detach();
		$('.navbar-nav').find('.nav-menu').detach();
		$('.navbar-nav').find('.show').removeClass('show');
		$('.menu-toggleable-left').removeClass('in');
		$('body').removeClass('noscroll');
		$('.main-menu').siblings().attr('aria-hidden', 'false');
		$('header').siblings().attr('aria-hidden', 'false');
		$('.navbar-toggler').removeClass('d-none');
		$('.navbar-toggler-close').addClass('d-none');
		$('.modal-background').hide();
		$('.promo-banner').removeClass('d-none');
		$('.navbar-toggler').focus();
		$('.navigation .header.container .col-12').css({'position': 'relative','z-index': 5,'background-color': 'white'});
		$('.chat').removeClass('z-0');
		$('.main-menu').attr('aria-hidden', 'true');
		$('.main-menu').siblings().attr('aria-hidden', 'false');
		$('header').siblings().attr('aria-hidden', 'false');
		$('.store-mode').css('padding', '0.5rem 1rem');
	});

	$('.navbar-nav').on('click', '.top-category .back-btn', function (e) {
		e.preventDefault();
		clearSelection(this);
		if($('.navbar-nav .top-category').length  == 0){
			$('.main-menu.menu-toggleable-left .search-mobile').removeClass('d-none');
		}
	});

	$('.navbar-nav').on('click', '.navbar-toggler-close', function (e) {
		e.preventDefault();
		$('.navbar-nav').find('.top-category').detach();
		$('.navbar-nav').find('.nav-menu').detach();
		$('.navbar-nav').find('.show').removeClass('show');
		$('.menu-toggleable-left').removeClass('in');
		$('body').removeClass('noscroll');
		$('.main-menu').siblings().attr('aria-hidden', 'false');
		$('header').siblings().attr('aria-hidden', 'false');

		$('.modal-background').hide();
	});

	$('.navbar-toggler').click(function (e) {
		e.preventDefault();
		if($($('.main-menu').find($('.search-mobile'))).length === 0) {
			var $mobileSearchClone = $('.search-mobile').clone(true);
			$mobileSearchClone.append('<div class="space-rectangle"></div>');
			$mobileSearchClone.prependTo($('.main-menu'));
		}
		$('.navigation .header.container .col-12').css({'position': 'relative','z-index': 7,'background-color': 'white'});
		$('.flyout-menu').hide();
		$('.main-menu').toggleClass('in');
		$('.modal-background').show();

		$('.main-menu').removeClass('d-none');
		$('.navbar-toggler').addClass('d-none');
		$('.nav-item[role="menuitem"]:first').css({
			'padding-top': '16px', 'border-top': '1px solid #eee','margin-top': '16px'});
		$('.navbar-toggler-close').removeClass('d-none');
		$('body').addClass('noscroll');
		$('.chat').addClass('z-0');
		$('.promo-banner').addClass('d-none');
		$('.main-menu').attr('aria-hidden', 'false');
		$('.main-menu').siblings().attr('aria-hidden', 'true');
		$('header').siblings().attr('aria-hidden', 'true');

		$('.main-menu .nav.navbar-nav .nav-link').first().focus();
		$('.store-mode').css('padding', '0');
	});

	keyboardAccessibility('.navbar-header .user',
		{
			40: function ($popover) { // down
				if ($popover.children('a').first().is(':focus')) {
					$popover.next().children().first().focus();
				} else {
					$popover.children('a').first().focus();
				}
			},
			38: function ($popover) { // up
				if ($popover.children('a').first().is(':focus')) {
					$(this).focus();
					$popover.removeClass('show');
				} else {
					$popover.children('a').first().focus();
				}
			},
			27: function () { // escape
				$('.navbar-header .user .popover').removeClass('show');
				$('.user').attr('aria-expanded', 'false');
			},
			9: function () { // tab
				$('.navbar-header .user .popover').removeClass('show');
				$('.user').attr('aria-expanded', 'false');
			}
		},
		function () {
			var $popover = $('.user .popover li.nav-item');
			return $popover;
		}
	);

	$('.navbar-header .user').on('mouseenter focusin', function () {
		if ($('.navbar-header .user .popover').length > 0) {
			$('.navbar-header .user .popover').addClass('show');
			$('.user').attr('aria-expanded', 'true');
		}
	});

	$('.main-menu ul li a').on('click',function(){
		sessionStorage.setItem('scrollPos',0);
	});

	$('.navbar-header .user').on('mouseleave', function () {
		$('.navbar-header .user .popover').removeClass('show');
		$('.user').attr('aria-expanded', 'false');
	});
	$('body').on('click', '#myaccount', function () {
		event.preventDefault();
	});

	$('.search-field').on('keyup focus', function () {
		var suggestValue = $(this).val();
		try{
			suggestValue = suggestValue.replace(/\+/g,' '); 
		}catch(e){
			suggestValue = $(this).val(); 
		}
		setTimeout(function () {
			if ($('.suggestions-wrapper').find('.suggestions')) {
				$('.entered-suggest-value').html('"' + suggestValue + '"...');
				$('.reset-button').addClass('d-block');
			} else {
				$('.reset-button').addClass('d-none');
			}
		}, 1500);

		if(suggestValue.length > 0){
			$('.reset-button').addClass('mobile-block');
		}
	});

	if ($('.store-mode').length > 0) {
		$('.menu-toggleable-left').addClass('inPos');
	}
};
